import React from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  label: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.6,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
}));

const FormSectionLabel = ({ children }) => {
  const { classes } = useStyles();

  return (
    <Grid size={12}>
      <div className={classes.label}>{children}</div>
    </Grid>
  );
};

export default FormSectionLabel;
